export default __webpack_public_path__ + "static/media/template-black-2955.23645ef9.png";